import { Link } from 'react-router-dom';
import './App.css';

const Home = () => {
    const links = [
         {
          url: "https://gamifiedlearning1.netlify.app/",
          imgSrc: "game.jpeg",
          text: "AI - Gamified Learning (Code Automata 2024)",
        },
        {
          url: "https://aifraud.netlify.app/",
          imgSrc: "fraud.jpg",
          text: "AI - Fraud Detection (HackSparks-1.0 2024)",
        },
        {
          url: "https://job404.netlify.app/",
          imgSrc: "job.png",
          text: "AI - Job Genuis (Edith AI Agent 2025) - Winner",
        },
        {
          url: "https://meditrack-mindsprint.vercel.app/",
          imgSrc: "medicine.jpg",
          text: "MediTrack (MindSprint 48 hours International 2025)",
        },
        {
          url: "https://team-duo-dare.vercel.app/",
          imgSrc: "space.jpg",
          text: "Space Explorer (PixxelHack-Webathon1.0 Round 1 2025)",
        },
        {
          url: "https://team-duo-dare-r2.vercel.app/",
          imgSrc: "mentor.jpg",
          text: "Education Tech (PixxelHack-Webathon1.0 Round 2 2025) - 1st Runner Up",
        },
        {
          url: "https://zennit-ui-hackathon.vercel.app/",
          imgSrc: "hackathon1.jpg",
          text: "Zennit UI - Hackathon Project",
        },
        {
          url: "https://genai-artwork-f.vercel.app/",
          imgSrc: "gen.jpg",
          text: "GenAI Artwork (GneAI Hackathon 2025)",
        },
      ];
    return(
        <>
        <div id="dynamicLinks">
          <p style={{margin: "0px", marginBottom: "10px", fontWeight: "500", fontFamily: "cursive"}}>Hackathon Projects</p>
            {links.map((link, index) => (
              <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                <div className="main-child">
                  <div className="img-view">
                    <img src={link.imgSrc} alt={link.text} />
                  </div>
                  <div className="text">
                    <p>{link.text}</p>
                  </div>
                </div>
              </a>
            ))}
        </div>
        </>
    )
};

export default Home;